

export default function useToken(){

    const tokenString = localStorage.getItem('token');
    
    const userToken = JSON.parse(tokenString);
  
    return userToken==null ? "" : userToken

}
function useUser(){

    const userIdString = localStorage.getItem('user');
    
    const user = JSON.parse(userIdString);
  
    return user==null ? "" : user

}


function useTerritory(){

    const territoryString = localStorage.getItem('territory');
    
    const userTerritory = JSON.parse(territoryString);
  
    return userTerritory==null ? "" : userTerritory

}

function useTenancy(){

    const tenancyString = localStorage.getItem('tenancy');
    
    const userTenancy = JSON.parse(tenancyString);
  
    return userTenancy==null ? "" : userTenancy

}


export { useTerritory, useTenancy, useUser }
